/** A running job never shows 100%: that reads as done while the row still says it is running. */
const RUNNING_MAX_PERCENT = 99;

/**
 * The percent a running job's bar shows, rounded and clamped to `0..99`; `undefined` until the
 * server reports one.
 */
export function toRunningPercent(progress: number | null | undefined): number | undefined {
  if (progress === null || progress === undefined) {
    return undefined;
  }

  return Math.max(0, Math.min(RUNNING_MAX_PERCENT, Math.round(progress)));
}
